import React, { useEffect, useCallback, useState} from 'react';
import EnvParam from './EnvParam.js';
import {connect} from 'react-redux';

const EnvParams = ({selectedParameter, setParameter, envelope, hasRelease, hasLevel, fullText}) => { 
    let params = [
        envelope.attackParameter,
        envelope.decayParameter,
        envelope.sustainParameter
    ];

    if (hasRelease) {
        params.push(envelope.releaseParameter);
    }

    if (hasLevel) {
        params.push(envelope.levelParameter);
    }
                  
    return (
        <div className="env-params">
          {params.map((param, i) => <EnvParam
                                 key={"param-" + i}
                                 selectedParameter={selectedParameter}
                                 setParameter={setParameter}
                                 parameter={param}
                                 fullText={fullText}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnvParams);
